export default class Tags {
  clientId = ''
  count = ''
  createTime = ''
  isDelete = ''
  middleUrl = ''
  smallUrl = ''
  synchronousTime = ''
  tagId = ''
  // tagName = ''
  name
  updateTime = ''
  url = ''
  userId = ''
  selected = false

  loadData = function (jsonData) {
    this.clientId = jsonData.clientId
    this.count = jsonData.count
    this.createTime = jsonData.createTime
    this.isDelete = jsonData.isDelete
    this.middleUrl = jsonData.middleUrl
    this.smallUrl = jsonData.smallUrl
    this.synchronousTime = jsonData.synchronousTime
    this.tagId = jsonData.tagId
    // this.tagName = jsonData.tagName
    this.name = jsonData.tagName
    this.updateTime = jsonData.updateTime
    this.url = jsonData.url
    this.userId = jsonData.userId
  }
}



// WEBPACK FOOTER //
// ./src/common/model/Tags.js